import { getWindow } from '../../utils/getWindow';
import { clearStoredScrollPositions } from '../../utils/useResetScroll';

export const buildSearchPostsScrollKey = (query: string) => `searchPostsScrollTop:${query}`;

export const buildSearchBusinessesScrollKey = (query: string) =>
    `searchBusinessesScrollTop:${query}`;

const SEARCH_SCROLL_STORAGE_PREFIXES = [
    buildSearchPostsScrollKey(''),
    buildSearchBusinessesScrollKey(''),
];

let activeSearchQuery: string | undefined;

export const prepareSearchScrollRestoration = (query: string) => {
    if (!getWindow()) {
        return;
    }

    if (activeSearchQuery !== undefined && activeSearchQuery !== query) {
        clearStoredScrollPositions((key) =>
            SEARCH_SCROLL_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix)),
        );
    }

    activeSearchQuery = query;
};
